export default {
  dialogTitle: "编辑画布",
  canvasName: {
    label: "画布名称",
    placeholder: "请输入画布名称(必填)",
  },
  canvasDescription: {
    label: "画布描述",
    placeholder: "请描述画布",
  },
  defaultAddress: {
    label: "默认地址",
    placeholder: "请输入默认地址",
  },
  buttons: {
    reset: "重置",
    confirm: "确认",
  },
  messages: {
    editSuccess: "修改成功",
    confirmEditRootNode:
      "修改主节点地址，该画布原有的分析内容将重置，是否要修改？",
    confirmTitle: "提示",
    confirmButton: "确定",
    cancelButton: "取消",
    cancelled: "已取消",
    ruleMessage: "案件名称为必填项",
  },
};
